import type { BarcodeErrorKey, BarcodeValidationResult } from '../types/barcode';

export const BARCODE_MAX_LENGTH = 80;
export const BARCODE_SAFE_PATTERN = /^[A-Za-z0-9 ._:/#+*-]+$/;

const BARCODE_ERROR_KEYS = new Set<BarcodeErrorKey>([
  'admin.products.errors.barcodeInvalid',
  'admin.products.errors.barcodeTooLong',
  'admin.products.errors.barcodeDuplicate',
  'admin.products.errors.barcodeDeletedConflict',
  'admin.products.errors.barcodeChangedElsewhere',
  'admin.barcode.errors.lookupFailed',
  'admin.barcode.errors.permissionDenied',
  'admin.barcode.errors.networkFailed',
  'admin.barcode.stock.errors.maxQuantity',
  'admin.barcode.errors.unknown',
]);

export function normalizeBarcode(rawBarcode: string): string {
  return String(rawBarcode).replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, '');
}

export function validateBarcode(rawBarcode: string): BarcodeValidationResult {
  const normalized = normalizeBarcode(rawBarcode);

  if (normalized.length === 0) {
    return {
      valid: false,
      normalized: null,
      errorKey: 'admin.products.errors.barcodeInvalid',
    };
  }

  if (normalized.length > BARCODE_MAX_LENGTH) {
    return {
      valid: false,
      normalized,
      errorKey: 'admin.products.errors.barcodeTooLong',
    };
  }

  if (!/[A-Za-z0-9]/.test(normalized) || !BARCODE_SAFE_PATTERN.test(normalized)) {
    return {
      valid: false,
      normalized,
      errorKey: 'admin.products.errors.barcodeInvalid',
    };
  }

  return { valid: true, normalized, errorKey: null };
}

export function isBarcodeErrorKey(value: unknown): value is BarcodeErrorKey {
  return typeof value === 'string' && BARCODE_ERROR_KEYS.has(value as BarcodeErrorKey);
}
